import { render, staticRenderFns } from "./stages-box.vue?vue&type=template&id=093bb39a&scoped=true&"
import script from "./stages-box.vue?vue&type=script&lang=js&"
export * from "./stages-box.vue?vue&type=script&lang=js&"
import style0 from "./stages-box.vue?vue&type=style&index=0&id=093bb39a&prod&lang=scss&"
import style1 from "./stages-box.vue?vue&type=style&index=1&id=093bb39a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093bb39a",
  null
  
)

export default component.exports